import { render, staticRenderFns } from "./KCBCertResponse.vue?vue&type=template&id=5f15778f&"
import script from "./KCBCertResponse.vue?vue&type=script&lang=js&"
export * from "./KCBCertResponse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports